import { render, staticRenderFns } from "./OccupancyModelAdminDownHelp.vue?vue&type=template&id=fdae3f6c&scoped=true"
import script from "./OccupancyModelAdminDownHelp.vue?vue&type=script&lang=js"
export * from "./OccupancyModelAdminDownHelp.vue?vue&type=script&lang=js"
import style0 from "./OccupancyModelAdminDownHelp.vue?vue&type=style&index=0&id=fdae3f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdae3f6c",
  null
  
)

export default component.exports